import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { IconButton } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { RightChevron, Gift } from 'baby-design/icons'

import { Reservation } from 'src/types/reservation'

import { useGiftGivers } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/context/GiftGiversProvider'
import css from './GiftProduct.styles.scss'
import ShipmentStatusSummaryBadge from '../../../ShipmentStatusSummaryBadge'
import { showGiftDetailsDrawer } from '../../../GiftDetailsDrawer'
import ImageAndQuantity from '../../../ImageAndQuantity'

const SurpriseMessage: FC = () => (
  <div className={css.GiftProduct__SurpriseMessage}>
    <Gift />
    <div>Surprise gift</div>
  </div>
)

const NameAndDeliveryBadge: FC<{ reservation: Reservation }> = ({
  reservation,
}) => (
  <div className={css.GiftProduct__NameAndDeliveryBadge}>
    <span className={css.GiftProduct__NameAndDeliveryBadge__Name}>
      {reservation.displayTitle}
    </span>
    <ShipmentStatusSummaryBadge
      {...{ shipmentStatusSummary: reservation.shipmentStatusSummary }}
    />
  </div>
)

const ProductDetails: FC<{ reservation: Reservation }> = ({ reservation }) => (
  <div className={css.GiftProduct__ProductDetails}>
    {reservation.isSurprise && <SurpriseMessage />}
    <NameAndDeliveryBadge {...{ reservation }} />
  </div>
)

const MoreDetailsButton: FC<{ reservationToken: string | undefined }> = ({
  reservationToken,
}) => {
  const { removeReservation } = useGiftGivers()

  const handleOpenGiftDetailsDrawer = async () => {
    if (!reservationToken) {
      return
    }

    const reservation = await showGiftDetailsDrawer({ reservationToken })
    if (reservation) {
      // it was ummarked as purchased, so remove it
      removeReservation(reservation)
    }
  }

  return (
    <div className={css.GiftProduct__MoreDetailsButton}>
      <IconButton
        size="md"
        variant="standard-default"
        onClick={handleOpenGiftDetailsDrawer}
      >
        <RightChevron />
      </IconButton>
    </div>
  )
}

const GiftProduct: FC<{ reservation: Reservation }> = ({ reservation }) => (
  <div className={css.GiftProduct}>
    <ImageAndQuantity reservation={reservation} />
    <ProductDetails reservation={reservation} />
    <MoreDetailsButton reservationToken={reservation.token} />
  </div>
)

export default GiftProduct
